import { type CreateInkColorInput, INK_COLOR_NAME_CONFLICT_MESSAGE } from '@repo/api-contracts';
import { trpc } from '@/shared/api';

interface UseCreateInkColorOptions {
  readonly onSuccess?: () => void;
}

/** 잉크 색상 추가 — 이름과 HEX 를 받는다. 색상 코드는 등록한 뒤 바꿀 수 없다. */
export const useCreateInkColor = ({ onSuccess }: UseCreateInkColorOptions = {}) => {
  const mutation = trpc.productManagement.inkColors.create.useMutation({ onSuccess });
  const message = mutation.error?.message ?? null;
  // 이름 충돌(409)은 이름만 바꿔 다시 등록하면 되므로 이름 칸에 보인다 — 코드가 아니라 계약 문구로 가른다.
  const isNameConflict = message === INK_COLOR_NAME_CONFLICT_MESSAGE;

  /** 성공하면 true — 추가 모달을 닫는 데 쓴다. 실패 사유는 error·nameError 로 남는다. */
  const createInkColor = async (input: CreateInkColorInput): Promise<boolean> => {
    try {
      // HEX 는 대문자로 보낸다(결정 F7) — color_code 는 바꿀 수 없고, dev 시드의 흔적 비교가 대소문자까지 본다.
      await mutation.mutateAsync({ name: input.name, colorCode: input.colorCode.toUpperCase() });
      return true;
    } catch {
      // 서버 거부 문구는 mutation.error 로 남아 모달에 보인다 — 여기서는 닫지 않을 신호만 준다.
      return false;
    }
  };

  return {
    createInkColor,
    isPending: mutation.isPending,
    error: isNameConflict ? null : message,
    nameError: isNameConflict ? message : null,
    /** 지난 오류를 지운다 — 추가 모달을 새로 열거나 닫을 때 쓴다. */
    reset: mutation.reset,
  };
};
